export const localization = {
  pt: {
    title: 'Criptografia ponta a ponta',
    subtitle:
      'O mTLS (abreviação de TLS mútuo no inglês) é um método de autenticação que verifica se cada parte em uma conexão de rede tem uma chave privada para garantir autenticidade da identifcação. Você pode cadastrar certificados de autenticação que serão usados nas suas operações no Blip.',
    button: 'Cadastrar novo certificado',
  },
  en: {
    title: 'End-to-End Encryption',
    subtitle:
      'mTLS (short for mutual TLS) is an authentication method that verifies that each end in a network connection has a private key to ensure their authenticity. You can register authentication certificates that will be available in your operations on Blip.',
    button: 'Register new certificate',
  },
  es: {
    title: 'Encriptado de fin a fin',
    subtitle:
      'mTLS (abreviatura de TLS mutuo) es un método de autenticación que verifica que cada parte en una conexión de red tenga una clave privada para garantizar la autenticidad de la identificación. Puedes registrar certificados de autenticación que se utilizarán en sus operaciones de Blip.',
    button: 'Registrar nuevo certificado',
  },
};
